import { warningToast } from "@idwal/idwal-react-components";

export function showRequestErrorToast(requestSection : string) {
    const errorMessage = "There has been a problem loading " + requestSection + " please refresh the page"
    warningToast(errorMessage);
}
